var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcApagadoMotorActivado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#5ba580;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-apagado-motor-activado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_35",
    "data-name": 35
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142,63.23v4.59H126.81V91h36.48a.41.41,0,0,1,.41.42v29.8h16.68V106.06h5.42v40.33h-5.42v-14.8H164.12V144.3a.84.84,0,0,1-.24.58L141.6,166.81a2.87,2.87,0,0,1-2,.84H99a2.9,2.9,0,0,1-2.15-1L84,152.55l-2-2.2H72.11A4.07,4.07,0,0,1,68,146.28V131.59H48.87v18.55H43.45V108.25h5.42V126.8H68V112.73a4.07,4.07,0,0,1,4.07-4.06h9.57l2-2.26L96.44,91.93a2.94,2.94,0,0,1,2.18-1h22.57V67.82H105.56V63.23H142m2.81-6.67h-42.1a3.85,3.85,0,0,0-3.85,3.86V70.63a3.85,3.85,0,0,0,3.85,3.86h11.78v9.79H98.62a9.59,9.59,0,0,0-7.18,3.24L78.67,102H72.11a10.73,10.73,0,0,0-10.74,10.73v7.4H55.54v-15A3.55,3.55,0,0,0,52,101.58H40.32a3.55,3.55,0,0,0-3.54,3.54v48.15a3.55,3.55,0,0,0,3.54,3.54H52a3.55,3.55,0,0,0,3.55-3.54v-15h5.83v8A10.74,10.74,0,0,0,72.11,157h7l12.78,14.14a9.55,9.55,0,0,0,7.1,3.16h40.59a9.55,9.55,0,0,0,6.72-2.76l22.28-21.93a7.48,7.48,0,0,0,2.23-5.33v-6h2.92v11a3.8,3.8,0,0,0,3.8,3.81h11.15a3.81,3.81,0,0,0,3.81-3.81V103.19a3.81,3.81,0,0,0-3.81-3.8H177.51a3.8,3.8,0,0,0-3.8,3.8V114.5h-3.34V91.37a7.08,7.08,0,0,0-7.08-7.09H133.48V74.49h11.36a3.86,3.86,0,0,0,3.86-3.86V60.42a3.86,3.86,0,0,0-3.86-3.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 89.16,
    y: 113.12,
    width: 64.19,
    height: 28.7,
    rx: 14.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 103.47,
    cy: 127.47,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApagadoMotorActivado);
export default __webpack_public_path__ + "static/media/ic-apagado-motor-activado.04d7b51527626c6726082600ad41a0c5.svg";
export { ForwardRef as ReactComponent };